import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import type { AppProps } from 'next/app';
import '@/styles/globals.css';
import UserDetailsContextProvider from '@/modules/RegisterLayout/contexts/UserDetailsContextProvider';
import RegistrationContextProvider from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import CourseContextProvider from '@/modules/RegisterLayout/contexts/CoursesContextProvider';
import { ThemeProvider, ToastProvider } from '@pw-tech/omni-ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { queryClientConfig } from '@/config/queryClient';
import FaroInitializer from '@/components/FaroInitializer';
const App = ({
  Component,
  pageProps
}: AppProps) => {
  const queryClientRef = useRef(new QueryClient(queryClientConfig));
  const router = useRouter();
  useEffect(() => {
    const isHomePath = router.pathname === '/';
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    if (isHomePath && !isLocalhost) {
      window.location.reload();
    }
  }, [router.pathname]);
  useEffect(() => {
    const isMaintenanceMode = process.env.NEXT_PUBLIC_MAINTENANCE_MODE === 'true';
    const isMaintenancePage = router.pathname === '/maintenance';
    if (isMaintenanceMode && !isMaintenancePage) {
      router.replace('/maintenance');
    }
  }, [router]);
  return <QueryClientProvider client={queryClientRef.current} data-sentry-element="QueryClientProvider" data-sentry-component="App" data-sentry-source-file="_app.tsx">
      <ThemeProvider data-sentry-element="ThemeProvider" data-sentry-source-file="_app.tsx">
        <ToastProvider data-sentry-element="ToastProvider" data-sentry-source-file="_app.tsx">
          <UserDetailsContextProvider data-sentry-element="UserDetailsContextProvider" data-sentry-source-file="_app.tsx">
            <FaroInitializer data-sentry-element="FaroInitializer" data-sentry-source-file="_app.tsx" />
            <RegistrationContextProvider data-sentry-element="RegistrationContextProvider" data-sentry-source-file="_app.tsx">
              <CourseContextProvider data-sentry-element="CourseContextProvider" data-sentry-source-file="_app.tsx">
                <Component {...pageProps} data-sentry-element="Component" data-sentry-source-file="_app.tsx" />
              </CourseContextProvider>
            </RegistrationContextProvider>
          </UserDetailsContextProvider>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>;
};
export default App;